import { gql } from '@apollo/client'
import React from 'react'

import { triggersClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useTriggerCallState = () => React.useContext(Context)
export const useTriggerCall = () => useTriggerCallState()?.triggerCall

const QUERY = gql`
  query TriggerCall($id: ID) {
    triggerCall(id: $id) {
      id
      status
      triggerId
      entityType
      entityId
      data
      updatedAt
    }
  }
`

const TriggerCallsLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: triggersClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default TriggerCallsLoader
